/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferCustomersControllerGetMigrationPreferencesQueryResponse, TransferCustomersControllerGetMigrationPreferencesPathParams, TransferCustomersControllerGetMigrationPreferences400, TransferCustomersControllerGetMigrationPreferences401, TransferCustomersControllerGetMigrationPreferences403, TransferCustomersControllerGetMigrationPreferences404 } from "../../models/transferCustomersController/TransferCustomersControllerGetMigrationPreferences";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { transferCustomersControllerGetMigrationPreferences } from "../../clients/transfer-customersService/transferCustomersControllerGetMigrationPreferences";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const transferCustomersControllerGetMigrationPreferencesQueryKey = (salesforceId: TransferCustomersControllerGetMigrationPreferencesPathParams["salesforceId"]) => [{
  url: '/api/v1/transfer-customers/:salesforceId/preferences',
  params: {
    salesforceId: salesforceId
  }
}] as const;
export type TransferCustomersControllerGetMigrationPreferencesQueryKey = ReturnType<typeof transferCustomersControllerGetMigrationPreferencesQueryKey>;
export function transferCustomersControllerGetMigrationPreferencesQueryOptions(salesforceId: TransferCustomersControllerGetMigrationPreferencesPathParams["salesforceId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = transferCustomersControllerGetMigrationPreferencesQueryKey(salesforceId);
  return queryOptions<TransferCustomersControllerGetMigrationPreferencesQueryResponse, ResponseErrorConfig<TransferCustomersControllerGetMigrationPreferences400 | TransferCustomersControllerGetMigrationPreferences401 | TransferCustomersControllerGetMigrationPreferences403 | TransferCustomersControllerGetMigrationPreferences404>, TransferCustomersControllerGetMigrationPreferencesQueryResponse, typeof queryKey>({
    enabled: !!salesforceId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return transferCustomersControllerGetMigrationPreferences(salesforceId, config);
    }
  });
}

/**
 * @summary Get migration preferences for a customer
 * {@link /api/v1/transfer-customers/:salesforceId/preferences}
 */
export function useTransferCustomersControllerGetMigrationPreferences<TData = TransferCustomersControllerGetMigrationPreferencesQueryResponse, TQueryData = TransferCustomersControllerGetMigrationPreferencesQueryResponse, TQueryKey extends QueryKey = TransferCustomersControllerGetMigrationPreferencesQueryKey>(salesforceId: TransferCustomersControllerGetMigrationPreferencesPathParams["salesforceId"], options: {
  query?: Partial<QueryObserverOptions<TransferCustomersControllerGetMigrationPreferencesQueryResponse, ResponseErrorConfig<TransferCustomersControllerGetMigrationPreferences400 | TransferCustomersControllerGetMigrationPreferences401 | TransferCustomersControllerGetMigrationPreferences403 | TransferCustomersControllerGetMigrationPreferences404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? transferCustomersControllerGetMigrationPreferencesQueryKey(salesforceId);
  const query = useQuery({
    ...transferCustomersControllerGetMigrationPreferencesQueryOptions(salesforceId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TransferCustomersControllerGetMigrationPreferences400 | TransferCustomersControllerGetMigrationPreferences401 | TransferCustomersControllerGetMigrationPreferences403 | TransferCustomersControllerGetMigrationPreferences404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}